import { observer } from "mobx-react-lite";

import { NodePointer } from "@/components/doc/right-sidebar/node-viewer/NodePointer";
import { FunctionNodeParameters } from "@/components/doc/right-sidebar/node-viewer/properties/FunctionNodeParameters";
import { NodeColorProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeColorProperty";
import { NodeNameProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeNameProperty";
import { NodeTypeProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeTypeProperty";
import { NodeValueProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeValueProperty";
import { isNodeEditable } from "@/components/tiptap/lock/utils";

import type { FunctionNodeModel } from "@/models/nodes/FunctionNodeModel";

type Props = {
  node: FunctionNodeModel;
  ids: Set<string>;
};

export const NodeFunction = observer(function NodeFunction({ node, ids }: Props) {
  return (
    <>
      <NodePointer>
        <NodeTypeProperty node={node} ids={ids} />
      </NodePointer>
      {(isNodeEditable(node) || node.value) && (
        <NodePointer>
          <NodeValueProperty node={node} ids={ids} />
          {ids.size === 1 && <FunctionNodeParameters node={node} />}
        </NodePointer>
      )}
      {(isNodeEditable(node) || node.name) && (
        <NodePointer>
          <NodeNameProperty node={node} />
        </NodePointer>
      )}
      <NodePointer>
        <NodeColorProperty node={node} />
      </NodePointer>
    </>
  );
});
